import Vue from 'vue';
import Vuex from 'vuex';
import downloadConfig from '@/config/downloadConfig';

Vue.use(Vuex);

const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language;
  },
};

const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language);
  },
};

export default new Vuex.Store({
  state: {
    // ios 需要下载的链接
    iosUrl: downloadConfig.ios.url,
    // android需要下载的链接
    AndroidUrl: downloadConfig.pub.url,
    // apkurl
    apkurl: downloadConfig.pub.url,
    // 点击邮箱需要跳转的链接
    supportUrl: 'mailto:help@totok.ai',
    // 当前语言
    language: 'en',
  },
  mutations,
  actions,
});
